import { useEffect, useState } from 'react';

import { fetchFileAsBlob } from '~/utils/fetchFileAsBlob';

// GET /chat/download requires auth — fetches as an authenticated blob before rendering inline.
export const useChatMediaUrl = (chatId: string, mediaKey: string | null | undefined, mimeType?: string) => {
    const [blobUrl, setBlobUrl] = useState<string | null>(null);
    const [downloadFileName, setDownloadFileName] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(Boolean(mediaKey));
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (!mediaKey) {
            setBlobUrl(null);
            setDownloadFileName(null);
            setIsLoading(false);
            return undefined;
        }

        let cancelled = false;
        let createdUrl: string | null = null;
        setIsLoading(true);
        setIsError(false);

        fetchFileAsBlob({
            mimeType,
            route: `/chat/download?chatId=${chatId}&key=${encodeURIComponent(mediaKey)}`,
        })
            .then(({ blobUrl: url, fileName }) => {
                if (cancelled) {
                    URL.revokeObjectURL(url);
                    return;
                }
                createdUrl = url;
                setBlobUrl(url);
                setDownloadFileName(fileName ?? null);
            })
            .catch(() => {
                if (!cancelled) setIsError(true);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
            if (createdUrl) URL.revokeObjectURL(createdUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chatId, mediaKey, mimeType]);

    return { blobUrl, downloadFileName, isError, isLoading };
};
